import React from 'react';

const QuestionView = ({ area, question, quiz }) => {

    if (quiz?.type === 'spinner') {
        return (
            <></>
        );
    }

    return (
        <div id="quiz-question-view">
            <div className={`images ${question.image2 || question.image3 ? 'multiple' : 'single'}`}>
                {/* Obrázek 1 */}
                {question.image1 ? (
                    <div>
                        <img src={`${question.image1}`} alt={`${question.correctAnswerArr[0]}`} />
                    </div>
                ) : (
                    <div className="fake-image">{question.correctAnswerArr?.[0]}</div>
                )}

                {/* Obrázek 2 */}
                {question.image2 ? (
                    <div>
                        <img src={`${question.image2}`} alt={`${question.correctAnswerArr[1]}`} />
                    </div>
                ) : (
                    question.correctAnswerArr?.[1] && (
                        <div className="fake-image">{question.correctAnswerArr[1]}</div>
                    )
                )}

                {/* Obrázek 3 */}
                {question.image3 ? (
                    <div>
                        <img src={`${question.image3}`} alt={`${question.correctAnswerArr[2]}`} />
                    </div>
                ) : (
                    question.correctAnswerArr?.[2] && (
                        <div className="fake-image">{question.correctAnswerArr[2]}</div>
                    )
                )}
            </div>
        </div>
    );
};

export default QuestionView;